import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function useModule () {
    const [moduleSelected, setModuleSelected] = useState("");
    let location = useLocation();
    useEffect(() => {
        if(location.pathname.includes("/infra/")) {
            setModuleSelected("Infrastructure");
        }
        else {
            setModuleSelected("Atmosly");
        }
    }, [location.pathname]);
    return [moduleSelected, setModuleSelected];
}